import { useState } from 'react';
import { deleteMaquina } from '../../services/maquinaService';

const useDeleteMaquina = () => {
    const [loadingDeleteMaquina, setLoadingDeleteMaquina] = useState(false);
    const [errorDeleteMaquina, setErrorDeleteMaquina] = useState<string | null>(null);

    const handleDeleteMaquina = async (id: string): Promise<boolean> => {
        setLoadingDeleteMaquina(true);
        setErrorDeleteMaquina(null);
        try {
            await deleteMaquina(id);
            return true;
        } catch (error) {
            setErrorDeleteMaquina('Erro ao deletar máquina');
            return false;
        } finally {
            setLoadingDeleteMaquina(false);
        }
    };

    return { handleDeleteMaquina, loadingDeleteMaquina, errorDeleteMaquina };
};

export default useDeleteMaquina;
